import { NeighborhoodExplorer } from "@/components/neighborhoods/NeighborhoodExplorer";

export default function NeighborhoodExplorerPage() {
  return <div data-testid="neighborhood-explorer-page"><NeighborhoodExplorer /></div>;
}